import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { pageVisit as _pageVisit, getCouponList as _getCouponList, getClassifyProductType as _getClassifyProductType, productNaturePrice, addCart as _addCart } from '@/services/http';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.loading = false; // 加载
    _this.couponList = []; // 优惠券商品列表
    _this.pageNo = 1; // 当前页数
    _this.pageSize = 10; // 每页显示条数
    _this.totalnumber = 0; // 总条数
    _this.productType = ''; // 分类搜索
    _this.naturelist = []; // 规格列表
    _this.priceList = []; // 价格列表
    _this.orderByprice = ''; // 价格排序
    _this.classifyList = []; // 分类列表
    _this.firstActive = ''; // 选中的第一分类
    _this.firstIndex = ''; // 选中的第一分类下标
    _this.couponIndex = 0;
    _this.secondActive = []; // 选中的第二分类
    _this.secondProductType = []; // 选中的第二分类列表
    _this.selectArr = []; // 所选规格列表
    _this.selectId = '';
    _this.thirdActive = 1; // 1综合、2价格
    _this.priceSort = 'asc'; // asc上升、desc下降
    // 选中重量
    _this.weight = '';
    _this.dialogVisible = false;
    // 是否下架
    _this.isshelf = false;
    // 选中价格
    _this.selectPrice = '';
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function () {
      var _created = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 3;
              return this.getClassifyProductType();
            case 3:
              _context.next = 5;
              return this.getCouponList();
            case 5:
              this.loading = false;
              this.pageVisit();
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function created() {
        return _created.apply(this, arguments);
      }
      return created;
    }()
  }, {
    key: "routechange",
    value: function routechange() {
      this.getCouponList();
    }
    // 全部点击回调
  }, {
    key: "handleAll",
    value: function handleAll() {
      if (this.firstActive === '') return;
      this.firstActive = '';
      this.secondActive = [];
      this.firstIndex = '';
      this.productType = '';
      this.thirdActive = 1;
      this.pageNo = 1;
      this.getCouponList();
    }
    // 一级分类点击回调
  }, {
    key: "setSecond",
    value: function setSecond(id, index) {
      if (this.firstActive === id) return;
      this.firstActive = id;
      this.secondActive = [];
      this.firstIndex = index;
      this.productType = id;
      this.pageNo = 1;
      this.getCouponList();
    }
    // 二级分类点击回调
  }, {
    key: "getClassify",
    value: function getClassify(item) {
      if (this.secondActive.length === 0) {
        this.secondActive.push(item.id);
        this.getCouponList();
      } else {
        if (this.secondActive.filter(function (e) {
          return e === item.id;
        }).length > 0) {
          for (var i = 0; i < this.secondActive.length; i += 1) {
            if (this.secondActive[i] === item.id) {
              this.secondActive.splice(i, 1);
              break;
            }
          }
        } else {
          this.secondActive.push(item.id);
        }
        this.getCouponList();
      }
    }
    // 综合、价格回调
  }, {
    key: "setThird",
    value: function setThird(num) {
      this.pageNo = 1;
      if (this.thirdActive === num && num === 1) return;
      var asc = document.querySelector('.el-icon-caret-top');
      var desc = document.querySelector('.el-icon-caret-bottom');
      if (num === 1) {
        asc.style.color = '#666';
        desc.style.color = '#666';
        this.priceSort = 'asc';
        this.orderByprice = '';
        this.thirdActive = num;
        this.getCouponList();
      } else if (num === 2) {
        this.priceSort = this.priceSort === 'asc' ? 'desc' : 'asc';
        if (this.priceSort === 'asc') {
          asc.style.color = '#666';
          desc.style.color = '#0043ff';
        } else {
          asc.style.color = '#0043ff';
          desc.style.color = '#666';
        }
        this.thirdActive = num;
        this.orderByprice = this.priceSort === 'asc' ? 'desc' : 'asc';
        this.getCouponList();
      }
    }
    // 获取商品规格价格
  }, {
    key: "getNaturePrice",
    value: function () {
      var _getNaturePrice = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(productId, key) {
        var _this2 = this;
        var res, arr;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return productNaturePrice({
                productId: productId,
                companyId: 1
              });
            case 2:
              res = _context2.sent;
              this.couponIndex = key;
              this.naturelist = res.data.data.nature;
              this.priceList = res.data.data.price;
              this.dialogVisible = true;
              arr = [];
              if (this.priceList.length > 0) {
                this.priceList[0].natureIds.split(',').map(Number).forEach(function (value, index) {
                  var obj = {
                    index: index,
                    id: value,
                    natureName: _this2.naturelist[index].data.filter(function (e) {
                      return e.id === value;
                    })[0].natureName,
                    natureValue: _this2.naturelist[index].data.filter(function (e) {
                      return e.id === value;
                    })[0].natureValue
                  };
                  arr.push(obj);
                });
              }
              this.selectArr = arr;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getNaturePrice(_x, _x2) {
        return _getNaturePrice.apply(this, arguments);
      }
      return getNaturePrice;
    }() // 加入购物车
  }, {
    key: "addCart",
    value: function () {
      var _addCart2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(id, num) {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              anchor = readCookie('anchor');
              _context3.next = 3;
              return _addCart({
                productPriceId: id,
                num: num,
                equip: anchor ? anchor.equip : '',
                version: anchor ? anchor.version : '',
                companyId: 1
              });
            case 3:
              res = _context3.sent;
              if (res.data.code === 100) {
                this.dialogVisible = false;
                this.$message.success('加入购物车成功');
                this.setCardNum();
              } else {
                this.$message.error(res.data.message);
              }
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function addCart(_x3, _x4) {
        return _addCart2.apply(this, arguments);
      }
      return addCart;
    }()
  }, {
    key: "goCard",
    value: function goCard() {
      this.$router.push('/card');
    }
    // 获取商品优惠券列表
  }, {
    key: "getCouponList",
    value: function () {
      var _getCouponList2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this3 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.loading = true;
              _context4.next = 3;
              return _getCouponList({
                couponId: this.$route.query.id,
                productType: this.productType,
                secondProductType: this.secondActive.join(','),
                productName: '',
                orderByprice: this.orderByprice,
                // eslint-disable-next-line no-nested-ternary
                // type: this.firstActive === '' ? '' : this.secondActive === '' ? 1 : 2,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                companyId: 1
              });
            case 3:
              res = _context4.sent;
              if (res.data.code === 100) {
                this.couponList = res.data.data.list;
                this.couponList.forEach(function (value) {
                  _this3.$set(value, 'val', 1);
                });
                this.totalnumber = res.data.data.total;
                this.loading = false;
              }
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getCouponList() {
        return _getCouponList2.apply(this, arguments);
      }
      return getCouponList;
    }() // 获取商品优惠券分类列表
  }, {
    key: "getClassifyProductType",
    value: function () {
      var _getClassifyProductType2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _getClassifyProductType({
                couponId: this.$route.query.id,
                companyId: 1
              });
            case 2:
              res = _context5.sent;
              if (res.data.code === 100) {
                this.classifyList = res.data.data;
              }
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getClassifyProductType() {
        return _getClassifyProductType2.apply(this, arguments);
      }
      return getClassifyProductType;
    }()
  }, {
    key: "selectNature",
    value: function selectNature(obj, index) {
      var _this4 = this;
      var id = obj.id,
        natureValue = obj.natureValue,
        natureName = obj.natureName;
      var target = {
        id: id,
        index: index,
        natureValue: natureValue,
        natureName: natureName
      };
      if (!this.isshelf) {
        if (this.selectArr.length === 0) {
          this.selectArr.push(target);
        } else {
          var boon = false;
          this.selectArr.forEach(function (value, indexs) {
            if (value.id === id) {
              _this4.selectArr = _this4.selectArr.filter(function (e) {
                return e.id !== id;
              });
              boon = true;
            } else if (value.index === index) {
              boon = true;
              _this4.selectArr[indexs].id = id;
              _this4.selectArr[indexs].natureValue = natureValue;
              _this4.selectArr[indexs].natureName = natureName;
            }
          });
          if (!boon) {
            this.selectArr.push(target);
          }
        }
        if (this.selectArr.length === this.naturelist.length) {
          var price = this.priceList.filter(function (e) {
            return e.natureIds.split(',').sort().join(',') === _this4.selectArr.map(function (ele) {
              return ele.id;
            }).sort().join(',');
          });
          this.selectPrice = String(price[0].price);
          this.selectId = price[0].id;
          var weight = this.priceList.filter(function (e) {
            return e.id === _this4.selectId;
          })[0].weight;
          this.weight = weight;
        } else {
          this.selectPrice = '';
          this.selectId = '';
        }
      }
    }
    // 没有所属规格置灰
  }, {
    key: "checkDisabled",
    value: function checkDisabled(id, index) {
      var _this5 = this;
      var flagCheck = false;
      var naturearrCheck = this.priceList.map(function (e) {
        return e.natureIds.split(',');
      });
      if (this.selectArr.length > 0) {
        naturearrCheck.forEach(function (_item) {
          var flagSum = 0;
          var lines = [];
          _this5.selectArr.forEach(function (item) {
            lines.push(item.index);
            if (_item.indexOf("".concat(item.id)) !== -1) {
              flagSum += 1;
            }
          });
          if (_item.indexOf("".concat(id)) !== -1 && flagSum >= 1) {
            if (flagSum >= _this5.selectArr.length - 1 && lines.indexOf(index) !== -1 || flagSum >= _this5.selectArr.length) {
              flagCheck = true;
            }
          }
        });
        if (flagCheck || this.selectArr.length === 1 && index === this.selectArr[0].index) {
          return false;
        }
        return true;
      }
      return false;
    }
  }, {
    key: "goDetails",
    value: function goDetails(id) {
      this.$router.push("/details?id=".concat(id));
    }
  }, {
    key: "handleCurrentChange",
    value: function handleCurrentChange(val) {
      this.pageNo = val;
      this.getCouponList();
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(val) {
      this.pageSize = val;
      this.getCouponList();
    }
    // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: 2,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
  }]);
}(Vue);
__decorate([Action('card/setCardNum')], default_1.prototype, "setCardNum", void 0);
__decorate([Watch('$route')], default_1.prototype, "routechange", null);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    BackTop: BackTop
  }
})], default_1);
export default default_1;